import { Component } from '@angular/core';
import { DataLoaderService, ResetService } from '../selectable-tabs/expert-screen-components/expert-service-call.index';

@Component({
    selector: 'special-mode-cancel',
    templateUrl: './special-mode-cancel.template.html',
    styleUrls: ['./special-mode-cancel.component.css']
})

export class SpecialModeCancelComponent {
    private options: any;
    constructor(private dataLoaderService: DataLoaderService, private resetService: ResetService) {
    }

    ngOnInit() {
        if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT' || this.dataLoaderService.data.additionalColor.length > 0) {
            this.options = "Color, Additional Color & Upholstery";
        }
        else {
            this.options = "Color & Upholstery";
        }
    }

    cancelConfiguration() {
        (<HTMLInputElement>document.getElementById('RETCODEID')).value = '0';
        (<HTMLFormElement>document.getElementById('form1')).action = this.dataLoaderService.vehicleInfo.hookURL + '';
        (<HTMLFormElement>document.getElementById('form1')).submit();
    }
    
    resetSpecial() {
        this.resetService.notifySpecialReset();
    }

}


// WEBPACK FOOTER //
// ./src/app/components/special-mode/special-mode-cancel.component.ts